import gsap from "gsap";
import slick from 'slick-carousel';

$( window ).on( 'load', function() {
    titleSlider();
});

$(window).ready( function() {
    heroAnimation();
    arrowDown();
});


function heroAnimation() {

    var tl = gsap.timeline().set('.circle', {opacity: 0});

    tl
        .to('.circle--1, .circle--3', {opacity: 0.15})
        .to('.circle--1, .circle--3', {opacity: 0},1)
        .to('.circle--2', {opacity: 0.18},1)
        .to('.circle--4', {opacity: 0.1},1)
        .to('.circle--2, .circle--4', {opacity: 0},2)
        .to('.circle--3', {opacity: 0.15},2)
        .to('.circle--5', {opacity: 0.1},2)
        .to('.circle--3, .circle--5', {opacity: 0},3)
        .to('.circle--4, .circle--6', {opacity: 0.1},3)
        .to('.circle--4, .circle--6', {opacity: 0},4)
        .to('.circle--5', {opacity: 0.1},4)
        .to('.circle--7', {opacity: 0.3},4)
        .to('.circle--5, .circle--7', {opacity: 0},5)
        .to('.circle--6', {opacity: 0.1},5)
        .to('.circle--8', {opacity: 1},5)
        .to('.circle--6, .circle--8', {opacity: 0},6)
        .to('.circle--1', {opacity: 0.15},7)
        .to('.circle--2', {opacity: 0.18},7)
        .to('.circle--3', {opacity: 0.15},7)
        .to('.circle--4', {opacity: 0.1},7)
        .to('.circle--5', {opacity: 0.1},7)
        .to('.circle--6', {opacity: 0.1},7)
        .to('.circle--7', {opacity: 0.3},7)
        .to('.circle--8', {opacity: 1},7)
        
}

function arrowDown() {
    $('.section-hero__arrow-down img').on('click', function() {
        var vheight = $(window).height();
        $('html, body').animate({
            scrollTop: (Math.floor($(window).scrollTop() / vheight)+1) * vheight
        }, 500); 
    });
}

function titleSlider() {
    $('.section-hero__title').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        dots: false,
    })
    .on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
}